<template>
	<div class="container-sm mh-100 pt-10">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection text="Editar" :breadcrumb="true" />
			</template>
		</LayoutHeaderSection>
		<main class="pt-8 vstack gap-10">
			<CommonFormWrapper submitText="Guardar" :cancelUrl="{ name: 'account.setting.index' }" :submitting="submitting" :errors="validationExternal" @submit="submit">
				<template #body>
					<CommonFormInputPassword v-model="target.new_password" title="Contraseña nueva" placeholder="Ingrese su nueva contraseña" :validation="validation.new_password" />
					<CommonFormInputPassword v-model="target.new_password_confirmation" title="Repetir contraseña nueva" placeholder="Repita su nueva contraseña" :validation="validation.new_password_confirmation" />
				</template>
			</CommonFormWrapper>
		</main>
	</div>
</template>

<script>
	import { reactive, toRefs } from 'vue';
	import router from '@/router';
	import useVuelidate from '@vuelidate/core';
	import { required, minLength, maxLength, sameAs } from '@/helpers/i18n/validators';
	import composableForm from '@/composables/form';
	import AuthRepository from '@/repositories/modules/Auth';

	export default {
		setup() {
			const { submitting, validationExternal, catchError } = composableForm();

			const target = reactive({
				new_password: null,
				new_password_confirmation: null
			});

			const { new_password } = toRefs(target, 'target');

			const validation = useVuelidate({
				new_password: {
					required,
					minLength: minLength(8),
					maxLength: maxLength(16)
				},
				new_password_confirmation: {
					required,
					minLength: minLength(8),
					maxLength: maxLength(16),
					sameAs: sameAs(new_password, 'contraseña nueva')
				}
			}, target);

			const submit = async () => {
				if(submitting.value) return;
				validationExternal.value = [];
				if(!await validation.value.$validate()) return;

				submitting.value = true;

				await AuthRepository.password(target).then((response) => {
					router.push({ name: 'account.setting.index' });
				}).catch(catchError);

				submitting.value = false;
			}

			return { target, submit, submitting, validation, validationExternal };
		}
	}
</script>